import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { httpRequest } from 'src/services/httpRequest';

export default function ViewMachineDetails() {
  const { applicationID } = useParams();
  const [data, setData] = useState([]);
  const handleGetApplicationDetails = async () => {
    try {
      const response = await httpRequest(
        'GET',
        `/clerk_vending/getByApplication/${applicationID}`
      );
      const fetchedCategories =
        response?.data.ApplicationID?.vendingMachines || [];
      setData(fetchedCategories);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  useEffect(() => {
    handleGetApplicationDetails();
  }, []);

  return (
    <Box
      sx={{
        maxWidth: '100%',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: 2,
        boxShadow: 3
      }}
    >
      <Box sx={{ padding: 3 }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ fontWeight: 'bold', marginBottom: 3 }}
        >
          Vending Machine Details
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Machine Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>
                  Fee
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((machine) => (
                <TableRow key={machine.ID}>
                  <TableCell>{machine?.MachineName}</TableCell>
                  <TableCell>{machine?.Location}</TableCell>
                  <TableCell align="right">
                    ${parseFloat(machine.Fee).toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
